import useSWR from 'swr'
import { api } from '@lib/orpc-client'

export type MigrationStatusResponse = Awaited<
  ReturnType<typeof api.wallet.migrations.status>
>
export type MigrationStatus = MigrationStatusResponse['status']

// Helper function to check if migration is in progress and should lock the user
export const isMigrationInProgress = (status?: MigrationStatus): boolean => {
  if (!status) return false

  // Migration is in progress if it's in any of these states
  const inProgressStates: MigrationStatus[] = [
    'JETTON_RETURN_INITIATED',
    'JETTON_RETURN_SUCCESS',
    'JETTON_RETURN_FAILED',
    'SC_MINT_INITIATED',
    'SC_MINT_FAILED'
  ]

  return inProgressStates.includes(status)
}

// Helper function to check if migration is completed
export const isMigrationCompleted = (status?: MigrationStatus): boolean => {
  if (!status) return false
  return status === 'COMPLETED_SC_MINT_SUCCESS' || status === 'COMPLETED_NO_JS'
}

export const useMigrationStatus = (refreshInterval?: number) => {
  const { data, error, isLoading, mutate } = useSWR(
    'wallet.migrations.status',
    async () => {
      try {
        const response = await api.wallet.migrations.status({})
        return response
      } catch (error) {
        throw error
      }
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 0,
      refreshInterval: refreshInterval
    }
  )

  return {
    data,
    error,
    isLoading,
    isError: !!error,
    mutate
  }
}
